import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

const { spacers } = baseVariables;

export const Wrapper = styled.div`
  gap: ${spacers?.spacers?.[3]};
`;
